<template>
	<sBox>
		<div slot="body">
			<div class="row">
				<div class="col-sm-1">
					<b>Num</b>
					<input v-model="cod" type="text" class="form-control" />
				</div>
				<div class="col-sm-3">
					<b>CNPJ \ Razão social</b>
					<input v-model="cnpj" type="text" class="form-control" />
				</div>
				<div class="col-sm-2">
					<b>Região</b>
					<select v-model="regiao" class="form-control">
						<option value="all">Todas</option>
						<option
							v-for="(reg, index) in assets.regioes"
							:key="index"
							:value="reg.regiao"
						>
							{{ reg.localidade }}
						</option>
					</select>
				</div>
				<div class="col-sm-2">
					<b>Status</b>
					<select v-model="situacao" class="form-control">
						<option value="all">Todos</option>
						<option value="moderacao">Moderação</option>
						<option value="distribuido">Ativo</option>
						<option value="ativo">Iniciado</option>
						<option value="suspenso">Suspenso</option>
					</select>
				</div>

				<div class="col-sm-2">
					<b>Origem</b>
					<select v-model="origem" class="form-control">
						<option value="all">Todos</option>
						<option value="1">Novo</option>
						<option value="0">Renovado</option>
					</select>
				</div>

				<!-- <div class="col-sm-2">
					<b>S. Pagto</b>
					<select disabled v-model="sPagto" class="form-control">
						<option value="all">Todos</option>
						<option value="">Adiado</option>
						<option value="approved">Aprovado</option>
						<option value="rejected">Rejeitado</option>
						<option value="pending">Pendente</option>
					</select>
				</div> -->

				<div class="col-sm-2">
					<b>Intervalo</b>
					<div class="input-group">
						<span class="input-group-addon">
							<i class="fa fa-calendar"></i>
						</span>
						<div class="form-control" id="datepicker-trigger">
							{{ fDate(dateOne) }} - {{ fDate(dateTwo) }}
						</div>
						<div class="cnt-airbnb">
							<div class="airbnb">
								<AirbnbStyleDatepicker
									id="wrapper-date"
									trigger-element-id="datepicker-trigger"
									:mode="'range'"
									:months-to-show="2"
									:date-one="dateOne"
									:date-two="dateTwo"
									:fullscreen-mobile="true"
									@date-one-selected="
										(val) => {
											dateOne = val;
										}
									"
									@date-two-selected="
										(val) => {
											dateTwo = val;
										}
									"
								/>
								<!--
            						        @closed='update' -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</sBox>
</template>
<script>
	import sBox from 'box';
	import fDate from 'js/date';
	import WBS from 'js/http';

	export default {
		components: { sBox },
		data() {
			let iniData = new Date();
			iniData.setMonth(iniData.getMonth() - 1);

			let hoje = new Date();
			hoje.setDate(hoje.getDate() + 15);
			return {
				cod: '',
				cnpj: '',
				regiao: 'all',
				situacao: 'all',
				sPagto: 'all',
				origem: 'all',
				dateOne: iniData,
				// dateOne: '2019-01-01',
				dateTwo: hoje,

				assets: {
					regioes: [],
					vendedores: [],
				},
			};
		},
		methods: {
			fDate(data, mask = 'DD xmxs') {
				let date = new Date(data);
				date.setDate(date.getDate() + 1);
				return fDate(date, mask);
			},
			update() {
				let filter = [];
				if (this.cod != '') filter.push(`cod = ${this.cod}`);

				let subNivel = false;
				if (this.cnpj != '') {
					subNivel = true;
					filter.push({
						table: 'propostas',
						find: 'cod',
						out: 'cod_proposta',
						where: {
							table: 'clientes',
							find: 'cnpj',
							where: `cnpj like '%${this.cnpj}%' or razao_social like '%${this.cnpj}%'`,
						},
					});
				}

				if (this.regiao != 'all') {
					subNivel = true;
					filter.push({
						table: 'propostas',
						find: 'cod',
						out: 'cod_proposta',
						where: {
							table: 'regioes',
							find: 'regiao',
							where: `regiao like '%${this.regiao}%'`,
						},
					});
				}

				if (this.situacao != 'all')
					filter.push(`status = '${this.situacao}'`);

				if (this.origem != 'all') {
					subNivel = true;
					filter.push({
						table: 'propostas',
						find: 'cod',
						out: 'cod_proposta',
						where: {
							table: 'propostas',
							find: 'new',
							where: `new = '${this.origem}'`,
						},
					});
				}

				// if(this.sPagto != 'all') filter.push(`payment.tStatus = '${this.sPagto}'`)

				filter.push(
					` ( data > '${this.fDate(
						this.dateOne,
						'YY-MM-DD'
					)}' and data < '${this.fDate(this.dateTwo, 'YY-MM-DD')}' ) `
				);

				if (subNivel) this.$emit('updateTab', filter);
				else this.$emit('updateTab', filter.join(' and '));

				// return filter.join(' and ')
			},
		},
		mounted() {
			WBS.send('protected-read-assetsPropostas', (resp) => {
				if (resp.status == 'success') {
					this.assets = resp.data;
				}
			});
			$('.form-control').change(this.update);
			$('.action-buttons > button:nth-child(2)').click(this.update);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/contracts/components/filter.vue